// extracted by mini-css-extract-plugin
export var ul = "expo-passe-module--ul--2frYt";
export var img = "expo-passe-module--img--ynWlj";